import type { Seminar } from 'services/seminars/types'

function filterAllowedStateProvinces(
  courseCountry: string,
  courseState?: string,
) {
  const allowedCountries = new Set(['US', 'CA'])

  return allowedCountries.has(courseCountry) ? courseState : null
}

type Props = {
  className?: string
  seminar: Seminar
}

function LocationTableCell({ seminar, className }: Props) {
  const text = seminar.isOnlineSeminar
    ? 'Online - Global'
    : [
        seminar.city,
        filterAllowedStateProvinces(seminar.country, seminar.state),
      ]
        .filter(Boolean)
        .join(', ')

  return (
    <td className={className}>
      <div>{text}</div>
      {seminar.countryLong && <div>{seminar.countryLong}</div>}
    </td>
  )
}

export default LocationTableCell
